// Set just before the Auth0 logout redirect so unsaved-changes beforeunload
// guards don't block it with a native "Leave site?" prompt. An idle auto-logout
// has nobody there to dismiss it, which would leave the session alive.
let loggingOut = false;

export function markLoggingOut() {
  loggingOut = true;
}

export function isLoggingOut() {
  return loggingOut;
}

// The flag normally dies with the page. If the redirect never happens, clear it
// so unsaved-changes warnings aren't suppressed for the rest of the session.
export function clearLoggingOut() {
  loggingOut = false;
}
